import { PropsWithChildren } from 'preact/compat';
import './FiltersPanelSection.less';
import Icon from '../icon/Icon';
import Collapsible from '../collapsible/Collapsible';

export type FiltersPanelSectionProps = PropsWithChildren<{
    className?: string;
    isExpanded: boolean;
    onToggleExpand?: () => void;
    animationDelayMs?: number;
    headerText: string;
    appliedQuantity: number;
}>;

const FiltersPanelSection = ({
    className = '',
    isExpanded,
    onToggleExpand,
    animationDelayMs = 0,
    headerText,
    appliedQuantity,
    children
}: FiltersPanelSectionProps) => (
    <div
        className={`bri-FiltersPanelSection ${className}`}
        style={{
            animationDelay: `${animationDelayMs}ms`
        }}
    >
        <div
            className="bri-FiltersPanelSection-header bri-BodyFont"
            onClick={onToggleExpand}
        >
            <span>
                {headerText}
                {appliedQuantity > 0 && <span>&nbsp;({appliedQuantity})</span>}
            </span>
            <Icon iconId={isExpanded ? 'chevron-up' : 'chevron-down'} />
        </div>
        <Collapsible isOpen={isExpanded}>
            <div className="bri-FiltersPanelSection-body">{children}</div>
        </Collapsible>
    </div>
);

export default FiltersPanelSection;
